"use strict";

var _interopRequireDefault = require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.string.starts-with");
require("core-js/modules/es6.object.keys");
require("core-js/modules/web.dom.iterable");
var _defineProperty2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/defineProperty.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/root/workspace/mall_vue_JOYE/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _whitelist = require("@/api/order/whitelist");
var _memberManagement = require("@/api/member/memberManagement");
var _index = require("@/utils/index");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; } //
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  name: 'WhitelistManagement',
  data: function data() {
    return {
      // 搜索表单数据
      searchForm: {
        mobilePhone: '',
        cardNo: ''
      },
      // 表格数据
      tableData: [],
      // 加载状态
      loading: false,
      // 分页相关
      currentPage: 1,
      pageSize: 10,
      total: 0,
      // 选中的ID列表
      selectedIds: [],
      // 弹窗相关
      dialogVisible: false,
      memberSearchForm: {
        mobilePhone: '',
        cardNo: ''
      },
      memberTableData: [],
      memberLoading: false,
      memberCurrentPage: 1,
      memberPageSize: 10,
      memberTotal: 0,
      selectedMember: null,
      selectedMemberId: null,
      imgPath: process.env.VUE_APP_IMAGE_PATH
    };
  },
  methods: {
    // 搜索功能
    handleSearch: function handleSearch() {
      this.currentPage = 1;
      this.fetchWhitelistList();
    },
    // 获取白名单列表
    fetchWhitelistList: function () {
      var _fetchWhitelistList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var params, response, _t;
        return regeneratorRuntime.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              this.loading = true;
              _context.prev = 1;
              params = _objectSpread(_objectSpread({}, this.searchForm), {}, {
                page: this.currentPage,
                limit: this.pageSize
              }); // 过滤空值参数
              Object.keys(params).forEach(function (key) {
                if (params[key] === '' || params[key] === null || params[key] === undefined) {
                  delete params[key];
                }
              });
              _context.next = 2;
              return (0, _whitelist.getWhitelistPage)(params);
            case 2:
              response = _context.sent;
              if (response.code === 200) {
                this.tableData = response.records || [];
                this.total = response.total || 0;
              } else {
                this.$message.error(response.message || '获取白名单列表失败');
              }
              _context.next = 4;
              break;
            case 3:
              _context.prev = 3;
              _t = _context["catch"](1);
              this.$message.error('获取白名单列表失败');
            case 4:
              _context.prev = 4;
              this.loading = false;
              return _context.finish(4);
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee, this, [[1, 3, 4, 5]]);
      }));
      function fetchWhitelistList() {
        return _fetchWhitelistList.apply(this, arguments);
      }
      return fetchWhitelistList;
    }(),
    // 表格行点击事件
    handleTableRowClick: function handleTableRowClick(row) {
      this.$refs.whitelistTable.toggleRowSelection(row);
    },
    // 选择变化
    handleSelectionChange: function handleSelectionChange(selection) {
      this.selectedIds = selection.map(function (item) {
        return item.id;
      });
    },
    // 批量删除
    handleBatchDelete: function handleBatchDelete() {
      var _this = this;
      if (this.selectedIds.length === 0) {
        this.$message.warning('请选择要删除的数据');
        return;
      }
      this.$confirm("\u786E\u8BA4\u5220\u9664\u9009\u4E2D\u7684 ".concat(this.selectedIds.length, " \u6761\u6570\u636E?"), '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
        var _t2;
        return regeneratorRuntime.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              _this.loading = true;
              _context2.next = 1;
              return (0, _whitelist.batchDeleteWhitelist)(_this.selectedIds);
            case 1:
              _this.$message.success('删除成功');
              _this.fetchWhitelistList();
              _context2.next = 3;
              break;
            case 2:
              _context2.prev = 2;
              _t2 = _context2["catch"](0);
              _this.$message.error('删除失败');
            case 3:
              _context2.prev = 3;
              _this.loading = false;
              return _context2.finish(3);
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, null, [[0, 2, 3, 4]]);
      })));
    },
    // 删除
    handleDelete: function handleDelete(row) {
      var _this2 = this;
      this.$confirm("\u786E\u8BA4\u5220\u9664\u8BE5\u767D\u540D\u5355\u6210\u5458?", '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee3() {
        var _t3;
        return regeneratorRuntime.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              _this2.loading = true;
              _context3.next = 1;
              return (0, _whitelist.deleteWhitelist)(row.id);
            case 1:
              _this2.$message.success('删除成功');
              _this2.fetchWhitelistList();
              _context3.next = 3;
              break;
            case 2:
              _context3.prev = 2;
              _t3 = _context3["catch"](0);
              _this2.$message.error('删除失败');
            case 3:
              _context3.prev = 3;
              _this2.loading = false;
              return _context3.finish(3);
            case 4:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 2, 3, 4]]);
      })));
    },
    // 添加白名单
    handleAdd: function handleAdd() {
      var _this3 = this;
      this.dialogVisible = true;
      // 清空筛选条件
      this.memberSearchForm = {
        mobilePhone: '',
        cardNo: ''
      };
      this.selectedMember = null;
      this.selectedMemberId = null;
      this.memberTableData = [];
      this.memberTotal = 0;
      // 清除当前选中行
      this.$nextTick(function () {
        if (_this3.$refs.memberTable) {
          _this3.$refs.memberTable.setCurrentRow(null);
        }
      });
    },
    // 搜索会员
    handleMemberSearch: function handleMemberSearch() {
      // 如果手机号和卡号都为空,不进行查询
      if (!this.memberSearchForm.mobilePhone && !this.memberSearchForm.cardNo) {
        this.$message.warning('请输入手机号或卡号进行查询');
        return;
      }
      this.memberCurrentPage = 1;
      this.fetchMemberList();
    },
    // 获取会员列表
    fetchMemberList: function () {
      var _fetchMemberList = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee4() {
        var _this4 = this;
        var params, response, _t4;
        return regeneratorRuntime.wrap(function (_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              this.memberLoading = true;
              _context4.prev = 1;
              params = _objectSpread(_objectSpread({}, this.memberSearchForm), {}, {
                page: this.memberCurrentPage,
                limit: this.memberPageSize
              }); // 过滤空值参数
              Object.keys(params).forEach(function (key) {
                if (params[key] === '' || params[key] === null || params[key] === undefined) {
                  delete params[key];
                }
              });
              _context4.next = 2;
              return (0, _memberManagement.xyUsersPage)(params);
            case 2:
              response = _context4.sent;
              if (response.code === 200) {
                this.memberTableData = response.records || [];
                this.memberTotal = response.total || 0;

                // 如果只有一行数据,默认选中
                if (this.memberTableData.length === 1) {
                  this.selectedMember = this.memberTableData[0];
                  this.$nextTick(function () {
                    if (_this4.$refs.memberTable) {
                      _this4.$refs.memberTable.setCurrentRow(_this4.memberTableData[0]);
                    }
                  });
                }
              } else {
                this.$message.error(response.message || '获取会员列表失败');
              }
              _context4.next = 4;
              break;
            case 3:
              _context4.prev = 3;
              _t4 = _context4["catch"](1);
              console.error('获取会员列表失败:', _t4);
              this.$message.error('获取会员列表失败');
            case 4:
              _context4.prev = 4;
              this.memberLoading = false;
              return _context4.finish(4);
            case 5:
            case "end":
              return _context4.stop();
          }
        }, _callee4, this, [[1, 3, 4, 5]]);
      }));
      function fetchMemberList() {
        return _fetchMemberList.apply(this, arguments);
      }
      return fetchMemberList;
    }(),
    // 获取行key
    getRowKey: function getRowKey(row) {
      return row.id;
    },
    // 行点击事件
    handleRowClick: function handleRowClick(row) {
      this.selectedMember = row;
    },
    // 当前行变化
    handleCurrentRowChange: function handleCurrentRowChange(val) {
      this.selectedMember = val;
      if (val) {
        this.selectedMemberId = val.id;
      }
    },
    // 提交新增
    handleSubmit: function () {
      var _handleSubmit = (0, _asyncToGenerator2.default)(/*#__PURE__*/regeneratorRuntime.mark(function _callee5() {
        var _t5;
        return regeneratorRuntime.wrap(function (_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              if (this.selectedMember) {
                _context5.next = 1;
                break;
              }
              this.$message.warning('请选择一个会员');
              return _context5.abrupt("return");
            case 1:
              _context5.prev = 1;
              this.loading = true;
              _context5.next = 2;
              return (0, _whitelist.addWhitelist)({
                userId: this.selectedMember.id
              });
            case 2:
              this.$message.success('添加成功');
              this.dialogVisible = false;
              this.fetchWhitelistList();
              _context5.next = 4;
              break;
            case 3:
              _context5.prev = 3;
              _t5 = _context5["catch"](1);
              this.$message.error('添加失败');
            case 4:
              _context5.prev = 4;
              this.loading = false;
              return _context5.finish(4);
            case 5:
            case "end":
              return _context5.stop();
          }
        }, _callee5, this, [[1, 3, 4, 5]]);
      }));
      function handleSubmit() {
        return _handleSubmit.apply(this, arguments);
      }
      return handleSubmit;
    }(),
    // 处理头像URL
    getAvatarUrl: function getAvatarUrl(userpic) {
      if (!userpic) return '';
      if (userpic.startsWith('http://') || userpic.startsWith('https://')) {
        return userpic;
      }
      return this.imgPath + userpic;
    },
    // 格式化时间
    formatTime: function formatTime(time) {
      if (!time) return '';
      return (0, _index.parseTime)(time, '{y}-{m}-{d} {h}:{i}:{s}');
    },
    // 获取注册方式文本
    getRegisterTypeText: function getRegisterTypeText(type) {
      var typeMap = {
        0: '系统注册',
        2: '点餐',
        3: '口碑',
        4: '社交',
        5: '支付宝'
      };
      return typeMap[type] || '未知';
    },
    // 分页大小改变
    handleSizeChange: function handleSizeChange(val) {
      this.pageSize = val;
      this.currentPage = 1;
      this.fetchWhitelistList();
    },
    // 当前页改变
    handleCurrentChange: function handleCurrentChange(val) {
      this.currentPage = val;
      this.fetchWhitelistList();
    },
    // 会员分页大小改变
    handleMemberSizeChange: function handleMemberSizeChange(val) {
      this.memberPageSize = val;
      this.memberCurrentPage = 1;
      this.fetchMemberList();
    },
    // 会员当前页改变
    handleMemberCurrentChange: function handleMemberCurrentChange(val) {
      this.memberCurrentPage = val;
      this.fetchMemberList();
    }
  },
  created: function created() {
    this.fetchWhitelistList();
  }
};